import React, { useEffect, useState } from 'react'
import {
  Button,
  Chip,
  Divider,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputLabel,
  makeStyles,
  MenuItem,
  OutlinedInput,
  Radio,
  RadioGroup,
  Select,
  Typography,
  Dialog,
  DialogContent,
  CircularProgress
} from '@material-ui/core'
import ViewHeader from 'components/ViewHeader'
import { useDispatch, useSelector } from 'react-redux'
import ProgressButton from 'components/ProgressButton'
import { useHistory, useParams } from 'react-router-dom'
import { addSession, fetchSessionById, resetSessionStore, updateSessionById } from 'store/session'
import ActionBar from 'components/ActionBar'
import CustomBox from 'components/Form/CustomBox'
import { fetchEventById, fetchEventTypes } from 'store/event'
import { Form, Formik } from 'formik'
import CustomTextField from 'components/Form/CustomTextField'
import DateTimeInput from 'components/DateTimeInput'
import { resetEventStore } from 'store/event'
import { sessionFromSchema } from 'schemas/session'
import moment from 'moment-timezone'
import { getDefaultTimezone } from 'utils/times'
import { fetchModerators } from 'store/moderator'
import venueSlice, { fetchVenues } from 'store/venue'
import { colors } from 'utils/colors'
import { getSpeakersAssociatedPolls } from 'store/speaker'
import pollingSlice, { alreadyUsedPoll, getSpeakerPolls, pollAttachOrDetach } from 'store/polling'
import { toast } from 'react-toastify'
import { AssociatedPollMsg, speakerStatus } from 'constants/index'
import { nanoid } from 'nanoid'
import TextField from '@material-ui/core/TextField'
import { Add, Warning } from '@material-ui/icons'
import VenueForm from 'views/admin/venue/VenueForm'
import CustomPopup from 'components/CustomPopup'
import EventCardForm from 'views/admin/eventCards/EventCardForm'
import ModeratorForm from 'views/admin/moderators/ModeratorForm'
import { removeUndefinedItemsFromArrayOfString } from 'utils'
import { isEqual } from 'lodash'
import PollingForm from 'views/admin/subjects/PollingForm/PollingForm'
import { Box } from '@mui/material'
import ReactQuill from 'react-quill'
import { modules } from 'views/admin/settings/SettingForm/TemplateForm'
import ErrorMessage from 'components/ErrorMessage'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
}

const emptyQuestion = {
  title: '',
  options: [
    { optId: nanoid(), opt: '' },
    { optId: nanoid(), opt: '' }
  ]
}
const pollInitialValues = {
  title: '',
  speakerId: '',
  questions: [emptyQuestion]
}

const SessionForm = () => {
  const classes = useStyles()
  const { eventId, sessionId } = useParams()
  const dispatch = useDispatch()
  const history = useHistory()
  const [loading, setLoading] = useState(false)
  const [changedSpeakerId, setChangedSpeakerId] = useState('')
  const [openVenueModal, setOpenVenueModal] = useState(false)
  const [openCardColorModal, setOpenCardColorModal] = useState(false)
  const [openModeratorModal, setOpenModeratorModal] = useState(false)
  const [openModeratorDropdown, setOpenModeratorDropdown] = useState(false)
  const [openAddPollModal, setOpenAddPollModal] = useState(false)
  const [pollValues, setPollValues] = useState(pollInitialValues)
  const [confirmModal, setConfirmModal] = useState(false)
  const [loadingPolls, setLoadingPolls] = useState(false)
  const [loadingSpeakers, setLoadingSpeakers] = useState(false)

  const { user } = useSelector((state) => state.auth)
  const { conference } = useSelector((state) => state.conference)
  const { event, eventTypes: cardColors } = useSelector((state) => state.event)
  const { session } = useSelector((state) => state.session)
  const { speakers } = useSelector((state) => state.speaker)
  const { venues } = useSelector((state) => state.venue)
  const { moderators } = useSelector((state) => state.moderator)
  const { polls } = useSelector((state) => state.polling)

  const defaultTimezone = getDefaultTimezone(conference?.timezone)

  const initialValues = {
    title: '',
    startDate: moment().tz(defaultTimezone),
    endDate: moment().tz(defaultTimezone),
    eventId: null,
    moderators: [],
    venueId: '',
    speakerId: null,
    pollId: null,
    keynotes: '',
    cardStyle: '',
    havePolls: 'no'
  }

  if (sessionId && session && session.id === sessionId) {
    initialValues.title = session.title
    initialValues.venueId = session.venueId
    initialValues.moderators = session.moderators ? session.moderators : []
    initialValues.startDate = moment(session.startDate).tz(
      conference ? conference?.timezone : defaultTimezone
    )
    initialValues.endDate = moment(session.endDate).tz(
      conference ? conference?.timezone : defaultTimezone
    )
    initialValues.keynotes = session.keynotes || ''
    initialValues.cardStyle = session.cardStyle || ''
    initialValues.havePolls = session.havePolls === true ? 'yes' : 'no'
    initialValues.speakerId = session.speakerId
    initialValues.pollId = session.pollId
  } else if (eventId && event?.id === eventId && !sessionId) {
    initialValues.venueId = event?.eventVenue
    initialValues.startDate = moment(event?.startDate).tz(defaultTimezone)
    initialValues.endDate = moment(event?.endDate).tz(defaultTimezone)
  } else if (event && event?.id === eventId) {
    initialValues.venueId = event.eventVenue
  }

  const handleCloseModal = (formValues) => {
    if (isEqual(pollValues, formValues)) {
      setOpenAddPollModal(false)
      setPollValues(pollInitialValues)
    } else {
      setConfirmModal(true)
    }
  }

  const handleCloseConfirmModal = () => {
    setConfirmModal(false)
    setOpenAddPollModal(false)
    setPollValues(pollInitialValues)
  }

  const handleReloadSpeakers = async () => {
    setLoadingSpeakers(true)
    await dispatch(getSpeakersAssociatedPolls(user?.conferenceId))
    setLoadingSpeakers(false)
  }

  useEffect(() => {
    if (sessionId) {
      dispatch(fetchSessionById(sessionId))
    }
    if (eventId) {
      dispatch(fetchEventById(eventId))
    }
    const unsubVenues = fetchVenues(user?.conferenceId, (venuesData) => {
      dispatch(venueSlice.actions.setVenues(venuesData))
    })
    dispatch(getSpeakersAssociatedPolls(user?.conferenceId))
    dispatch(fetchEventTypes())
    dispatch(fetchModerators())

    return () => unsubVenues && unsubVenues()
  }, [sessionId, eventId, user?.conferenceId])

  useEffect(() => {
    if (session?.speakerId) setChangedSpeakerId(session?.speakerId)
  }, [session?.speakerId])

  useEffect(() => {
    if (changedSpeakerId) {
      setLoadingPolls(true)
      const unsubSpeakerPolls = getSpeakerPolls(user?.conferenceId, changedSpeakerId, (data) => {
        dispatch(pollingSlice.actions.setPolls(data))
        setLoadingPolls(false)
      })
      return () => unsubSpeakerPolls && unsubSpeakerPolls()
    } else dispatch(pollingSlice.actions.setPolls([]))
  }, [dispatch, changedSpeakerId])

  const goBack = () => {
    dispatch(resetSessionStore())
    dispatch(resetEventStore())
    return history.goBack()
  }

  const handleChange = (e) => {
    setChangedSpeakerId(e.target.value)
  }

  const onSubmit = async (
    {
      title,
      startDate,
      endDate,
      moderators,
      venueId,
      speakerId,
      pollId,
      havePolls,
      keynotes,
      cardStyle
    },
    { setFieldError }
  ) => {
    const sDate = typeof startDate === 'number' ? startDate : startDate.valueOf()
    const eDate = typeof endDate === 'number' ? endDate : endDate.valueOf()

    let hasError = false
    if (sDate < event.startDate) {
      setFieldError('startDate', {
        errType: 'Time',
        msg: 'Start time can not be before event start time'
      })
      hasError = true
    }

    if (sDate > event.endDate) {
      setFieldError('startDate', {
        errType: 'Time',
        msg: 'Start time can not be after event end time'
      })
      hasError = true
    }

    if (eDate < event.startDate) {
      setFieldError('endDate', {
        errType: 'Time',
        msg: 'End time can not be before event start time'
      })
      hasError = true
    }

    if (eDate > event.endDate) {
      setFieldError('endDate', {
        errType: 'Time',
        msg: 'End time can not be after event end time'
      })
      hasError = true
    }

    if (hasError) return

    setLoading(true)
    const payload = {
      title: title.trim(),
      venueId: venueId.trim(),
      startDate: moment(sDate).utc().valueOf(),
      endDate: moment(eDate).utc().valueOf(),
      eventId: eventId,
      havePolls: havePolls === 'yes',
      speakerId: havePolls === 'yes' ? speakerId : null,
      pollId: havePolls === 'yes' ? pollId : null,
      moderators: removeUndefinedItemsFromArrayOfString(moderators),
      keynotes: keynotes.trim(),
      cardStyle
    }

    let newSessionId
    if (sessionId) {
      if (payload.havePolls && session?.pollId !== payload.pollId) {
        const isAlreadyUsed = await alreadyUsedPoll(payload.pollId)
        if (isAlreadyUsed) {
          toast.warning(AssociatedPollMsg)
          setLoading(false)
          return
        }
      }
      await dispatch(updateSessionById(sessionId, payload))
    } else if (payload.havePolls) {
      const isAlreadyUsed = await alreadyUsedPoll(payload.pollId)
      if (isAlreadyUsed) {
        toast.warning(AssociatedPollMsg)
        setLoading(false)
        return
      }
      newSessionId = await dispatch(
        addSession({
          ...payload,
          pinCode: nanoid(6)
        })
      )
    } else {
      newSessionId = await dispatch(
        addSession({
          ...payload,
          pinCode: nanoid(6)
        })
      )
    }
    if (
      (payload.havePolls && session?.pollId !== payload.pollId) ||
      (!payload?.havePolls && sessionId)
    ) {
      await pollAttachOrDetach(session?.pollId, {
        eventId: null,
        sessionId: null,
        talkId: null,
        alreadyUsed: false
      })
    }
    if (payload.havePolls && payload.pollId) {
      await pollAttachOrDetach(payload.pollId, {
        eventId: event?.id,
        sessionId: newSessionId ? newSessionId : sessionId,
        talkId: '',
        alreadyUsed: true
      })
    }
    setLoading(false)
    goBack()
  }

  return (
    <CustomBox>
      <ViewHeader title={sessionId ? 'Edit session' : 'Create session'}>
        <div style={{ marginRight: 10 }}>
          <ActionBar actionText="Back" onAction={goBack} />
        </div>
      </ViewHeader>
      <Formik
        initialValues={initialValues}
        enableReinitialize
        onSubmit={onSubmit}
        validationSchema={sessionFromSchema}>
        {({ values, touched, errors, setFieldValue }) => (
          <Form>
            <Grid container spacing={3}>
              <Grid item xs={12} md={8}>
                <CustomTextField label="Session Title" name="title" type="text" />
              </Grid>
              <Grid item xs={12} lg={4}>
                <TextField
                  select
                  fullWidth
                  label="Card Color"
                  variant="outlined"
                  error={Boolean(touched.cardStyle && errors.cardStyle)}
                  value={values.cardStyle}
                  onChange={(event) =>
                    event.target.value && setFieldValue('cardStyle', event.target.value)
                  }
                  helperText={touched.cardStyle && errors.cardStyle ? errors.cardStyle : null}>
                  {cardColors?.map((cardColor) => (
                    <MenuItem value={cardColor.id} key={cardColor.id}>
                      <Box className={classes.menuItem}>
                        <Box
                          sx={{
                            width: '18px',
                            height: '18px',
                            borderRadius: '4px',
                            backgroundColor: cardColor.bgColor ?? ''
                          }}></Box>
                        <Typography>{cardColor.type}</Typography>
                      </Box>
                    </MenuItem>
                  ))}
                  <Divider />
                  <MenuItem onClick={() => setOpenCardColorModal(true)}>
                    <Typography className={classes.buttonItem}>
                      <Add />
                      Create card color
                    </Typography>
                  </MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={12} md={6} lg={4}>
                    <DateTimeInput
                      value={values.startDate}
                      dateLabel="Event Start Date"
                      timeLabel="Event Start Time"
                      name="startDate"
                      is24hrFormat={conference?.is24hrFormat}
                      minDate={
                        event &&
                        moment(event.startDate).tz(
                          conference ? conference?.timezone : defaultTimezone
                        )
                      }
                      maxDate={
                        event &&
                        moment(event.endDate).tz(
                          conference ? conference?.timezone : defaultTimezone
                        )
                      }
                      onChange={(value) => {
                        setFieldValue('startDate', value)
                        if (!sessionId) {
                          setFieldValue('endDate', value)
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={4}>
                    <DateTimeInput
                      value={values.endDate}
                      dateLabel="Event End Date"
                      timeLabel="Event End Time"
                      name="endDate"
                      is24hrFormat={conference?.is24hrFormat}
                      minDate={
                        event &&
                        moment(event.startDate).tz(
                          conference ? conference?.timezone : defaultTimezone
                        )
                      }
                      maxDate={
                        event &&
                        moment(event.endDate).tz(
                          conference ? conference?.timezone : defaultTimezone
                        )
                      }
                      onChange={(value) => setFieldValue('endDate', value)}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  select
                  fullWidth
                  label="Venue"
                  variant="outlined"
                  error={Boolean(touched.venueId && errors.venueId)}
                  value={values.venueId}
                  onChange={(event) =>
                    event.target.value && setFieldValue('venueId', event.target.value)
                  }
                  helperText={touched.venueId && errors.venueId ? errors.venueId : null}>
                  {venues?.map((venue) => (
                    <MenuItem value={venue.id} key={venue.id}>
                      <Typography>{venue.venueText}</Typography>
                    </MenuItem>
                  ))}
                  <Divider />
                  <MenuItem onClick={() => setOpenVenueModal(true)}>
                    <Typography className={classes.buttonItem}>
                      <Add />
                      Create venue
                    </Typography>
                  </MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControl
                  fullWidth
                  variant="outlined"
                  error={!!errors.moderators && touched.moderators}>
                  <InputLabel>Moderators</InputLabel>
                  <Select
                    multiple
                    open={openModeratorDropdown}
                    onOpen={() => setOpenModeratorDropdown(true)}
                    onClose={() => setOpenModeratorDropdown(false)}
                    name="moderators"
                    value={values.moderators}
                    onChange={(event) => {
                      const value = event.target.value
                      if (value) {
                        setFieldValue(
                          'moderators',
                          typeof value === 'string' ? value.split(',') : value
                        )
                      }
                    }}
                    input={<OutlinedInput id="select-multiple-chip" label="Moderator" />}
                    renderValue={(selected) => (
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                        {selected.map(
                          (value) =>
                            value && (
                              <Chip
                                style={{
                                  background: colors.indigo,
                                  color: 'white'
                                }}
                                key={value}
                                label={moderators?.find((s) => s.id === value)?.fullName}
                              />
                            )
                        )}
                      </Box>
                    )}
                    MenuProps={MenuProps}>
                    {moderators &&
                      !!moderators.length &&
                      moderators?.map((o) => (
                        <MenuItem value={o.id} key={o.id}>
                          {o?.fullName}
                        </MenuItem>
                      ))}
                    <Divider />
                    <MenuItem
                      className={classes.nonSelectedMenu}
                      onClick={() => {
                        setOpenModeratorDropdown(false)
                        setOpenModeratorModal(true)
                      }}>
                      <Typography className={classes.buttonItem}>
                        <Add />
                        Create moderator
                      </Typography>
                    </MenuItem>
                  </Select>
                  {touched.moderators && <FormHelperText>{errors.moderators}</FormHelperText>}
                </FormControl>
              </Grid>

              {conference?.havePolls && (
                <>
                  <Grid item xs={12}>
                    <Box className={classes.radioGroup}>
                      <Typography className={classes.radioLabel}>
                        Do you want to associate a poll with this session?
                      </Typography>
                      <RadioGroup
                        row
                        value={values.havePolls}
                        onChange={(e) => setFieldValue('havePolls', e.target.value)}>
                        <FormControlLabel
                          control={<Radio size="small" />}
                          label={<Typography variant="body2">Yes</Typography>}
                          value="yes"
                        />
                        <FormControlLabel
                          control={<Radio size="small" />}
                          label={<Typography variant="body2">No</Typography>}
                          value="no"
                        />
                      </RadioGroup>
                    </Box>
                  </Grid>
                  {values.havePolls === 'yes' && (
                    <>
                      <Grid item xs={12} lg={6}>
                        {!loadingSpeakers && (
                          <TextField
                            select
                            fullWidth
                            className={classes.selectSpeakerMenu}
                            name="speakerId"
                            label="Speaker"
                            variant="outlined"
                            error={Boolean(touched.speakerId && errors.speakerId)}
                            value={values.speakerId}
                            onChange={(event) => {
                              setFieldValue('pollId', '')
                              event.target.value && setFieldValue('speakerId', event.target.value)
                              handleChange(event)
                            }}
                            helperText={
                              touched.speakerId && errors.speakerId ? errors.speakerId : null
                            }>
                            {speakers?.map((speaker) => (
                              <MenuItem
                                value={speaker.id}
                                key={speaker.id}
                                className={classes.listItem}>
                                {speaker?.isSubject && speaker?.fullName
                                  ? speaker?.fullName
                                  : speaker?.isSubject && !speaker?.fullName
                                  ? speaker.email
                                  : speaker.fullName}
                                {speaker?.isSubject &&
                                  speaker?.status === speakerStatus.PENDING && (
                                    <Chip
                                      size="small"
                                      className={classes.chip}
                                      color="primary"
                                      label={
                                        <Typography className={classes.chipLabel}>
                                          {speaker?.status === speakerStatus.PENDING
                                            ? 'Not Approved'
                                            : 'Approved'}
                                        </Typography>
                                      }
                                    />
                                  )}
                              </MenuItem>
                            ))}
                          </TextField>
                        )}
                        {loadingSpeakers && (
                          <Box className={classes.loadingFieldBox}>
                            <CircularProgress size={20} />
                            <Typography>Loading speakers...</Typography>
                          </Box>
                        )}
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '1rem',
                            height: '100%'
                          }}>
                          {!loadingPolls && (
                            <TextField
                              select
                              fullWidth
                              label="Associated Poll"
                              variant="outlined"
                              error={Boolean(touched.pollId && errors.pollId)}
                              value={values.pollId}
                              onChange={(event) =>
                                event.target.value && setFieldValue('pollId', event.target.value)
                              }
                              helperText={touched.pollId && errors.pollId ? errors.pollId : null}>
                              {polls?.map((poll) => (
                                <MenuItem value={poll.id} key={poll.id}>
                                  <Typography>{poll.title}</Typography>
                                </MenuItem>
                              ))}
                              <Divider />
                              <MenuItem onClick={() => setOpenAddPollModal(true)}>
                                <Typography className={classes.buttonItem}>
                                  <Add />
                                  Create poll
                                </Typography>
                              </MenuItem>
                            </TextField>
                          )}
                          {loadingPolls && (
                            <Box className={classes.loadingFieldBox}>
                              <CircularProgress size={20} />
                              <Typography>Loading polls...</Typography>
                            </Box>
                          )}
                        </Box>
                      </Grid>
                    </>
                  )}
                </>
              )}

              <Grid item xs={12}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
                  <label className={classes.label}>Keynotes</label>
                  <ReactQuill
                    theme="snow"
                    modules={modules}
                    value={values.keynotes}
                    onChange={(value) => setFieldValue('keynotes', value)}
                    placeholder="Write keynotes here..."
                  />
                  <ErrorMessage message={touched?.keynotes && errors?.keynotes} />
                </Box>
              </Grid>
            </Grid>
            <Grid container spacing={2} className={classes.actionButtons}>
              <Grid item>
                <Button disabled={loading} size="large" onClick={goBack}>
                  Cancel
                </Button>
              </Grid>
              <Grid item>
                <ProgressButton
                  type="submit"
                  label="Save"
                  inProgress={loading}
                  disabled={loading}
                />
              </Grid>
            </Grid>
            <Dialog fullWidth maxWidth="xl" open={openAddPollModal}>
              <DialogContent className={classes.pollModalContent}>
                <PollingForm
                  forApproval={true}
                  editedPollId={null}
                  pollValues={pollValues}
                  speakerId={null}
                  conferenceId={user?.conferenceId}
                  associateSpeaker={true}
                  subjectId={null}
                  handleCloseModal={handleCloseModal}
                  handleCloseConfirmModal={() => setOpenAddPollModal(false)}
                  onSuccess={async (pollId, newSpeakerId) => {
                    await handleReloadSpeakers()
                    setChangedSpeakerId(newSpeakerId)
                    setFieldValue('speakerId', newSpeakerId)
                    setFieldValue('pollId', pollId)
                  }}
                />
              </DialogContent>
            </Dialog>
            <Dialog
              fullWidth
              maxWidth="sm"
              open={confirmModal}
              onClose={() => setConfirmModal(false)}>
              <Box className={classes.warningModalHeader}>
                <Warning className={classes.warningIcon} />
                <Typography className={classes.warningTitle}>Warning</Typography>
              </Box>
              <DialogContent className={classes.modalContent}>
                <Typography variant="body2">
                  Any unsaved data will be lost. Press CANCEL to go back and save these changes, or
                  OK to discard these changes.
                </Typography>

                <Box className={classes.actions}>
                  <Button
                    size="small"
                    variant="contained"
                    color="primary"
                    onClick={handleCloseConfirmModal}>
                    ok
                  </Button>
                  <Button size="medium" onClick={() => setConfirmModal(false)}>
                    cancel
                  </Button>
                </Box>
              </DialogContent>
            </Dialog>
            <CustomPopup
              title="Create venue"
              maxWidth="lg"
              open={openVenueModal}
              onClose={() => setOpenVenueModal(false)}>
              <VenueForm
                displayContext="modal"
                onCloseModal={() => setOpenVenueModal(false)}
                onSuccess={(venueId) => {
                  setOpenVenueModal(false)
                  setFieldValue('venueId', venueId)
                }}
              />
            </CustomPopup>
            <CustomPopup
              title="Create card color"
              maxWidth="lg"
              open={openCardColorModal}
              onClose={() => setOpenCardColorModal(false)}>
              <EventCardForm
                displayContext="modal"
                onCloseModal={() => setOpenCardColorModal(false)}
                onSuccess={(cardColorId) => {
                  setOpenCardColorModal(false)
                  setFieldValue('cardStyle', cardColorId)
                }}
              />
            </CustomPopup>
            <CustomPopup
              title="Create moderator"
              maxWidth="md"
              open={openModeratorModal}
              onClose={() => setOpenModeratorModal(false)}>
              <ModeratorForm
                displayContext="modal"
                onCloseModal={() => setOpenModeratorModal(false)}
                onSuccess={(moderatorId) => {
                  setOpenModeratorModal(false)
                  setFieldValue(
                    'moderators',
                    values?.moderators?.length > 0
                      ? [...values.moderators, moderatorId]
                      : [moderatorId]
                  )
                }}
              />
            </CustomPopup>
          </Form>
        )}
      </Formik>
    </CustomBox>
  )
}
export default SessionForm

const useStyles = makeStyles({
  label: {
    fontSize: '13px',
    letterSpacing: '0.5px',
    color: '#606060'
  },
  chipLabel: {
    fontSize: '13px',
    letterSpacing: '0.5px',
    fontWeight: 'bold'
  },
  selectSpeakerMenu: {
    '& .MuiOutlinedInput-root': {
      '& .MuiSelect-outlined.MuiSelect-outlined': {
        display: 'flex',
        alignItems: 'center',
        gap: '1rem'
      }
    }
  },
  listItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem'
  },
  chip: {
    background: '#c62828',
    color: '#FFFFFF'
  },
  radioGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem'
  },
  radioLabel: {
    fontWeight: 600,
    fontSize: '16px',
    color: '#2f2f2f'
  },
  actionButtons: {
    marginTop: '16px',
    display: 'flex',
    justifyContent: 'end'
  },
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem'
  },
  buttonItem: {
    color: colors.indigo,
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    gap: '0.3rem'
  },
  warningModalHeader: {
    padding: '20px 20px 10px 20px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  },
  warningIcon: {
    color: '#ffa726'
  },
  warningTitle: {
    fontSize: '16px',
    fontWeight: 'bold'
  },
  modalContent: {
    padding: '4px 16px 4px 22px'
  },
  actions: {
    marginTop: '20px',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
    marginBottom: '10px'
  },
  loadingFieldBox: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '1rem',
    gap: '1rem',
    height: '100%',
    border: '1px solid #dedede',
    borderRadius: '8px',
    width: '100%'
  },
  nonSelectedMenu: {
    backgroundColor: '#ffffff !important'
  }
})
